import { c } from 'react-compiler-runtime';
import { clsx } from 'clsx';
import classes from './Label.module.css.js';
import React from 'react';
import { jsx } from 'react/jsx-runtime';
import Box from '../Box/Box.js';

const Label = /*#__PURE__*/React.forwardRef(function Label(t0, ref) {
  const $ = c(23);
  let as;
  let className;
  let rest;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      as,
      size: t1,
      variant: t2,
      className,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = as;
    $[2] = className;
    $[3] = rest;
    $[4] = t1;
    $[5] = t2;
  } else {
    as = $[1];
    className = $[2];
    rest = $[3];
    t1 = $[4];
    t2 = $[5];
  }
  const size = t1 === undefined ? "small" : t1;
  const variant = t2 === undefined ? "default" : t2;
  const Component = as || "span";
  if (rest.sx) {
    let t3;
    if ($[6] !== className) {
      t3 = clsx(className, classes.Label);
      $[6] = className;
      $[7] = t3;
    } else {
      t3 = $[7];
    }
    let t4;
    if ($[8] !== Component || $[9] !== ref || $[10] !== rest || $[11] !== size || $[12] !== t3 || $[13] !== variant) {
      t4 = /*#__PURE__*/jsx(Box, {
        as: Component,
        className: t3,
        "data-size": size,
        "data-variant": variant,
        ref: ref,
        ...rest
      });
      $[8] = Component;
      $[9] = ref;
      $[10] = rest;
      $[11] = size;
      $[12] = t3;
      $[13] = variant;
      $[14] = t4;
    } else {
      t4 = $[14];
    }
    return t4;
  }
  let t3;
  if ($[15] !== className) {
    t3 = clsx(className, classes.Label);
    $[15] = className;
    $[16] = t3;
  } else {
    t3 = $[16];
  }
  let t4;
  if ($[17] !== Component || $[18] !== rest || $[19] !== size || $[20] !== t3 || $[21] !== variant) {
    t4 = /*#__PURE__*/jsx(Component, {
      className: t3,
      "data-size": size,
      "data-variant": variant,
      ...rest
    });
    $[17] = Component;
    $[18] = rest;
    $[19] = size;
    $[20] = t3;
    $[21] = variant;
    $[22] = t4;
  } else {
    t4 = $[22];
  }
  return t4;
});

export { Label as default };
